




































import mixins from 'vue-typed-mixins'

import I18N from '@/components/I18N.ts'

import axios from 'axios'

interface Data {
  working: boolean,
  lemma: string | null,
  gloss: string | null,
  pos: string | null
}

export default mixins(I18N).extend({
  props: {
    word: String,
    pos_options: Array
  },
  data (): Data {
    return {
      working: false,
      lemma: null,
      gloss: null,
      pos: 'NOUN'
    }
  },
  methods: {
    submitSuggestion (): void {
      this.$store.dispatch('clearMessages')
      if (!this.lemma || !this.gloss || !this.pos) {
        this.$store.dispatch('addError', this.__('suggest.invalid'))
        return
      }
      this.working = true
      axios.post(`${process.env.VUE_APP_API_URL}/feedback/suggest`, {
        lemma: this.lemma,
        gloss: this.gloss,
        pos: this.pos
      })
        .then(response => {
          this.$emit('hide')
          this.$emit('done')
        })
        .catch(error => {
          this.$store.dispatch('addError', error)
        })
        .then(() => {
          this.working = false
        })
    }
  },
  watch: {
    word: {
      handler (): void {
        this.lemma = this.word
        this.gloss = null
      },
      immediate: true
    }
  }
})
